module.exports = __webpack_public_path__ + "img/_contacts_check.9d90fc1c.svg";